import React, { useEffect } from "react";
import { useBluetooth } from "../BluetoothContext";
import play from "../components/play.png";
import stop from "../components/stop.png";
import { useNavigate } from "react-router-dom";

const FindRemote: React.FC = () => {
  const { device, findRemote } = useBluetooth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!device) {
      navigate("/"); 
    }
  }, [device, navigate]);

  if (!device) {
    return null; 
  }

  const handlePlaySound = () => findRemote("y");
  const handleStopSound = () => findRemote("n");

  return (
    <div>
      <h1>
        <strong>Find Remote</strong>
      </h1>
      <p>Current Remote Name: {device.name}</p>
      <div className="home-buttons">
        <div className="connect-container">
          <button
            className="connect-button play-button"
            onClick={handlePlaySound}
          >
            <img src={play} alt="play sound" />
            PLAY SOUND
          </button>
        </div>
        <div className="find-container">
          <button
            className="find-button stop-button"
            onClick={handleStopSound}
          >
            <img src={stop} alt="stop sound" />
            STOP SOUND
          </button>
        </div>
      </div>
    </div>
  );
};

export default FindRemote;
